export default __webpack_public_path__ + "static/media/Countries.0437d79a.svg";